import api from './client';

export interface ClientInfo {
  name: string;
  email: string;
  phone: string;
  address: string;
}

export interface LineItem {
  description: string;
  quantity: number;
  unit_price: number;
}

export interface PDFGenerateRequest {
  title: string;
  document_number: string;
  date: string;
  client: ClientInfo;
  items: LineItem[];
  notes?: string;
  template_name?: string;
}

export const pdfApi = {
  /**
   * Generate a PDF document from a template
   * @param request - PDF generation request with template data
   * @returns PDF file as blob
   */
  generate: async (request: PDFGenerateRequest): Promise<Blob> => {
    const { data } = await api.post('/pdf/generate', request, {
      responseType: 'blob',
    });
    return data;
  },
};
